// TrustShop exposes its main copy as translated metafields, but these two
// interface labels are hard-coded by the widget. Leave customer reviews intact.
(() => {
  const localize = () => {
    const root = document.getElementById('trustshop-review');
    if (!root) return;
    root.querySelectorAll('.trustshop-review-sort--wrap > span').forEach(label => {
      if (label.textContent.trim() === 'Sort by') label.textContent = '排序方式';
    });
    root.querySelectorAll('button[aria-label="Mark review as helpful"]').forEach(button => {
      button.setAttribute('aria-label', '將這則評論標記為有幫助');
    });
  };
  localize();
  // The app also replaces its controls when sorting or loading more reviews.
  new MutationObserver(localize).observe(document.body, { childList: true, subtree: true });
})();
